module.exports = __webpack_public_path__ + "static/notary-d6b82002691b2c795113e2dce0714379.jpg";